import type { ExplainAudio } from './useExplainAudio';

const noop = () => {};

const SILENT: ExplainAudio = {
  track: null,
  playing: false,
  t: 0,
  done: false,
  loading: false,
  error: false,
  hidden: false,
  rate: 1,
  progress: 0,
  cycleRate: noop,
  toggle: noop,
  retry: noop,
  stop: noop,
  reset: noop,
  pause: noop,
};

export const useSilentAudio = (): ExplainAudio => SILENT;
